import {Injectable} from '@angular/core';
import { Route, Router, UrlSegment } from '@angular/router';
import {Observable} from 'rxjs';
import {KeycloakService} from 'keycloak-angular';
import {Role} from '../../clm/types/role.enum';

@Injectable({
  providedIn: 'root'
})
export class OnboardingAdminPortalGuard  {
  userRoles: string[];
  private readonly rolesRequiredForOnBoardingAdminPortal: string[] = [Role.OnBoardingManager, Role.OnBoardingTeamLeader];

  constructor(
    private router: Router,
    private keycloakService: KeycloakService) {
    this.userRoles = this.keycloakService.getUserRoles();
  }

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    const hasExpectedRole: boolean = this.rolesRequiredForOnBoardingAdminPortal.some((role: string) => this.userRoles.includes(role));
    if (!this.userRoles.length || !hasExpectedRole) {
      this.router.navigateByUrl('/');
      return false;
    }
    return true;
  }

}
